export enum InvestigationAiAnalysisType {
	Complete = 1,
	Incomplete = 2,
	Conflict = 3,
	NewIssue = 4,
}
